var compQuestao = Vue.component('questao', {
    props: {
        id                  : Number,
        contador            : Number,
        tipo                : String,
        enunciado           : Object,
        gabarito            : String,
        acertou             : String,
        grupo               : String,
        prova               : Object,
        ano                 : Number,
        disciplina          : Object,
        assuntos            : Array,
        orgao               : Object,
        banca               : Object,
        areasconhecimento   : Array,
        cargos              : Array,
        tabs                : Object
    },
    data: function() {
        return {
            pai                     : vmQuestoes,
            tabAtiva                : null,
            alternativaSelecionada  : null,
            verGabarito             : false,
            destacarVerde           : null,
            destacarVermelho        : null,
            respondido              : null,
            ajaxFeito               : false,
            mostrarTexto            : false,
            resolucoes              : [],
            materiais               : [],
            audios                  : [],
            estatisticas            : [],
            criarComp               : {
                resolucoes  : false,
                comentarios : false,
                audios      : false,
                materiais   : false,
                anotacoes   : false,
                estatisticas: false
            },
            carregando              : {
                resolucoes  : true,
                discussoes  : true,
                audios      : true,
                materiais   : true,
                anotacoes   : true,
                estatisticas: true
            }
        }
    },
    template: '#questao-template',
    methods: {
        mapaDeDisciplinas: function ( questaoId ){
            if( ! vmQuestoes.logado  ){
                return nav.open('register');
            }

            fechaTooltips();
            vmDisciplinasAssuntos.abrirModal( questaoId );
        },
        abrirTab: function ( nomeTab ) {

            if( ! vmQuestoes.logado  ){
                return nav.open('register');
            }

            var self = this;
            var prevTab = this.tabAtiva;

            /* Clique na mesma tab, já aberta: só fecha*/
            if( this.tabAtiva == nomeTab ) {
                var cont = '#conteudo-' + this.tabAtiva + '-' + this.id;
                $(cont).slideUp(function () {
                    self.tabAtiva = null;
                });
                return;
            }

            /* Se tem uma tab aberta, fecha ela */
            if( prevTab ){
                var tabAnterior = '#conteudo-' + this.tabAtiva + '-' + this.id;
                $(tabAnterior).slideUp();
            }

            /* Abre a nova tab */
            var conteudo = '#conteudo-' + nomeTab + '-' + self.id;
            self.tabAtiva = nomeTab;

            $(conteudo).slideDown(function(){

                /* Só faço UM Ajax pra cada aba */
                if( ! self.criarComp[nomeTab] ) {

                    /* Isso faz com que o respectivo componente seja criado (aciona o v-if),
                     * e um AJAX seja feito no create(), para carregar os dados da tab.
                     * */
                    self.criarComp[nomeTab] = true;
                }

            });
        },
        selecionaAlternativa: function (alternativa_id) {

            this.respondido  = null;
            this.destacarVerde = null;
            this.destacarVermelho = null;
            this.verGabarito = false;

            // Desseleciona
            if( this.alternativaSelecionada == alternativa_id ){
                return this.alternativaSelecionada = null;
            }

            this.alternativaSelecionada = alternativa_id;
        },
        responder: function () {

            var self = this;

            if( ! vmQuestoes.logado  ){
                return nav.open('register');
            }

            /* Só guardo no BD a primeira tentativa!
            *  Como eu revelo o gabarito caso o usuário erre,
            *  não faz sentido gravar as tentativas seguintes.
            */
            if( ! this.ajaxFeito ){

                ajaxPOST(
                    '/questao/responder',
                    { questaoId: this.id, resposta: this.alternativaSelecionada },
                    function () {
                        self.ajaxFeito = true;
                    }
                );
            }

            if( this.alternativaSelecionada == this.gabarito ){
                this.destacarVerde = this.alternativaSelecionada;
                this.destacarVermelho = null;
                this.respondido = 'certo';
                if( this.acertou == '-1' ){
                    this.acertou = '1';
                }
            }else{
                this.destacarVermelho = this.alternativaSelecionada;
                this.respondido = 'errado';
                if( this.acertou == '-1' ){
                    this.acertou = '0';
                }
            }
        }
    },
    created: function(){
        this.contador += vmQuestoes.offset();
        this.ajaxFeito = (this.acertou != '-1');
    },
    ready: function () {

        var self = this;
        MathJax.Hub.PreProcess('questao-' + self.id);
        Vue.nextTick(function () {
            MathJax.Hub.Process('questao-' + self.id);
        });

        /* Ultima questão da página? Reprocessa MathJax! */
        /*if( (this.contador == this.$parent.totalQuestoes) ||
            (this.contador == this.$parent.paginaAtual * this.$parent.questoesPorPag)
        ){
            setTimeout(function () {
                MathJax.Hub.Reprocess();
            }, 3000);
        }*/
    }
});

